import { useNavigate } from 'react-router-dom'
import { Tabs, TabsProps } from 'antd'
import ButtonLink from 'components/button/Button'
import { VoucherStatusEnum } from '../hooks/useVoucher'

interface CardHeaderVouchersProps {
  title: string
  labelButton: string
  navigateTo: string
  onChangeTab: (key: VoucherStatusEnum) => void
}

export default function CardHeaderVouchers(props: CardHeaderVouchersProps) {
  const { title, labelButton, navigateTo, onChangeTab } = props
  const items: TabsProps['items'] = [
    {
      key: VoucherStatusEnum.ACTIVE,
      label: 'Voucher Aktif',
    },
    {
      key: VoucherStatusEnum.INACTIVE,
      label: 'Riwayat Voucher',
    },
  ]
  const navigate = useNavigate()

  return (
    <div>
      <div className="block xl:flex xl:justify-between pb-0">
        <div className="xl:w-2/5 xl:flex w-full">
          <h3 className="m-0 text-xl text-[#323539] self-center">{title}</h3>
        </div>
        <div className="xl:w-auto w-full">
          <ButtonLink
            data-testid="button-create-voucher"
            variant="solid-primary"
            block={true}
            label={labelButton}
            className="py-3 px-4 text-sm font-bold"
            onClick={() => navigate(navigateTo)}
          />
        </div>
      </div>
      <div>
        <hr className="my-4 border-[#E5E5E7] border-solid" />
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={key => onChangeTab(key as VoucherStatusEnum)}
        />
      </div>
    </div>
  )
}
